import { time } from "vue-app-utils-web";
const currentTime = time;
export { currentTime };
